module.exports = __webpack_public_path__ + "static/media/bannerprincipal.667222e6.svg";